__turbopack_context__.v({
  "bannerText": "BroadcastBanner-module__lgLIOq__bannerText",
});
